function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @property {XMLHttpRequest} xhr
 * @property {string} url
 * @property {*} payload
 * @property {string} method
 * @property {string|null} contentType
 */
var Ajax = /*#__PURE__*/function () {
  /**
   * @param {string} url
   * @param {string} method
   * @param {Function} onProgress
   * @param {string} responseType
   */
  function Ajax(url, method) {
    var onProgress = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var responseType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";

    _classCallCheck(this, Ajax);

    this.xhr = new XMLHttpRequest();
    if (onProgress) this.xhr.onprogress = function (event) {
      return onProgress(event);
    };
    this.url = url.replace(/\/+$/, '');
    this.payload = null;
    this.method = method;
    this._headers = {};
    this.xhr.responseType = responseType;
    return this;
  }
  /**
   * @param {string} key
   * @param {string} value
   * @returns {Ajax}
   */


  _createClass(Ajax, [{
    key: "header",
    value: function header(key, value) {
      this._headers[key] = value;
      return this;
    }
    /**
     * @param headers
     * @returns {Ajax}
     */

  }, {
    key: "headers",
    value: function headers(_headers) {
      this._headers = _objectSpread(_objectSpread({}, this._headers), _headers);
      return this;
    }
    /**
     * @param {number} timeout
     * @returns {Ajax}
     */

  }, {
    key: "timeout",
    value: function timeout(_timeout) {
      this.xhr.timeout = _timeout;
      return this;
    }
    /**
     * @returns {Promise<XMLHttpRequest>}
     */

  }, {
    key: "promise",
    value: function promise() {
      var _this = this;

      var responseType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      if (responseType !== null) this.xhr.responseType = responseType;
      return new Promise(function (resolve, reject) {
        _this.xhr.onreadystatechange = function () {
          if (_this.xhr.readyState === 4) resolve(_this.xhr);
        };

        _this.xhr.onerror = function (event) {
          reject(event);
        };

        _this.xhr.ontimeout = function (event) {
          reject(event);
        };

        _this.xhr.open(_this.method, _this.url);

        if (_this.contentType) {
          _this.xhr.setRequestHeader('Content-type', _this.contentType);
        }

        for (var key in _this._headers) {
          _this.xhr.setRequestHeader(key, _this._headers[key]);
        }

        _this.xhr.send(_this.payload);
      });
    }
    /**
     * @returns {Promise<XMLHttpRequest>}
     */

  }, {
    key: "get",
    get: function get() {
      return this.promise('');
    }
    /**
     * @returns {Promise<XMLHttpRequest>}
     */

  }, {
    key: "getString",
    get: function get() {
      return this.promise('');
    }
    /**
     * @returns {Promise<XMLHttpRequest>}
     */

  }, {
    key: "getJson",
    get: function get() {
      return this.promise('json');
    }
    /**
     * @returns {Promise<XMLHttpRequest>}
     */

  }, {
    key: "getArrayBuffer",
    get: function get() {
      return this.promise('arraybuffer');
    }
    /**
     * @returns {Promise<XMLHttpRequest>}
     */

  }, {
    key: "getBlob",
    get: function get() {
      return this.promise('blob');
    }
    /**
     * @returns {Promise<XMLHttpRequest>}
     */

  }, {
    key: "getDocument",
    get: function get() {
      return this.promise('document');
    }
    /**
     * @returns {Promise<XMLHttpRequest>}
     */

  }, {
    key: "getText",
    get: function get() {
      return this.promise('text');
    }
  }], [{
    key: "request",
    value:
    /**
     * @param {string} url
     * @param {string} method
     * @param {Function} onProgress
     * @returns {Ajax}
     */
    function request(url, method) {
      var onProgress = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      return new Ajax(url, method, onProgress);
    }
    /**
     * @param {string} url
     * @param {Function} onProgress
     * @returns {Ajax}
     */

  }, {
    key: "get",
    value: function get(url) {
      var onProgress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return Ajax.request(url, Ajax.method.get, onProgress);
    }
    /**
     * @param {string} url
     * @param {*} data
     * @param {Function} onProgress
     * @returns {Ajax}
     */

  }, {
    key: "post",
    value: function post(url) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var onProgress = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var request = Ajax.request(url, Ajax.method.post, onProgress);
      var formData = new FormData();

      for (var name in data) {
        if (data.hasOwnProperty(name)) formData.append(name, data[name]);
      }

      request.payload = formData;
      return request;
    }
    /**
     * @param {string} url
     * @param {*} data
     * @param {Function} onProgress
     * @returns {Ajax}
     */

  }, {
    key: "upload",
    value: function upload(url) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var files = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var onProgress = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var request = this.post(url, data, onProgress);
      this.contentType = 'multipart/form-data';
      if (!(files instanceof Array)) files = [files];
      files.forEach(function (file) {
        return request.payload.append('file', file, file.name);
      });
      return request;
    }
    /**
     * @param {string} url
     * @param {*} data
     * @param {Function} onProgress
     * @returns {Ajax}
     */

  }, {
    key: "json",
    value: function json(url) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var onProgress = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var request = Ajax.request(url, Ajax.method.post, onProgress);
      request.payload = JSON.stringify(data);
      request.contentType = 'application/json';
      return request;
    }
    /**
     * @param url
     * @param onProgress
     * @returns {Ajax}
     */

  }, {
    key: "delete",
    value: function _delete(url) {
      var onProgress = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      return Ajax.request(url, Ajax.method.delete, onProgress);
    }
  }]);

  return Ajax;
}();

_defineProperty(Ajax, "method", {
  get: 'GET',
  post: 'POST',
  put: 'PUT',
  patch: 'PATCH',
  delete: 'DELETE'
});

export { Ajax as default };